import { useSelector } from "react-redux";

import {
  DataType,
  GraphConfig,
  GraphType,
} from "@intelligems/ig-types/schemas/analytics/custom-graphs";
import { STANDARD_EVENTS_ALLOWED_KEY_METRICS } from "@intelligems/ig-types/dtos/analytics-events/standard-events";
import { shortId } from "@intelligems/ig-utils/common";
import { getKeyMetricName } from "@src/features/experienceMetrics/helpers";
import { getKeyMetricsRich } from "@src/store/slices/experienceMetrics/experienceMetrics";
import { InvertedMetrics } from "@src/types/standard-events";

export function useGenerateGraphConfig(): GraphConfig[] {
  const experienceKeyMetrics = useSelector(getKeyMetricsRich);
  return experienceKeyMetrics.map((keyMetric) => {
    return {
      title: [
        keyMetric?.experienceCustomMetric
          ? keyMetric.experienceCustomMetric.customEvent.name
          : getKeyMetricName(keyMetric),
      ],
      datasetId: "variation_overview",
      isImpactGraph: true,
      graphType:
        keyMetric?.standardEventId === "netRevenuePerOrder"
          ? GraphType.StackedBar
          : GraphType.Bar,
      metrics:
        keyMetric?.standardEventId === "netRevenuePerOrder"
          ? [
              "net_product_revenue_per_order",
              "net_shipping_revenue_per_order",
              "net_revenue_per_order",
            ]
          : [
              keyMetric?.standardEventId
                ? STANDARD_EVENTS_ALLOWED_KEY_METRICS[keyMetric.standardEventId]
                    .analyticsMetricId
                : keyMetric?.experienceCustomMetric?.customEvent?.id
                  ? shortId(keyMetric.experienceCustomMetric.customEvent.id)
                  : "unknown",
              "n_orders",
              "n_visitors",
              "net_revenue",
            ],
      canBeKeyMetric: true,
      hasProbability: true,
      hasTimeseries: true,
      hasValueCI: true,
      hasAudience: true,
      hasImpactCalculation: keyMetric?.standardEventId
        ? STANDARD_EVENTS_ALLOWED_KEY_METRICS[keyMetric?.standardEventId]
            .hasImpactCalculation
        : false,
      impactMetric:
        keyMetric?.standardEventId === "netRevenuePerOrder"
          ? "net_revenue_per_order"
          : undefined,
      stackedBarLegendTitles:
        keyMetric?.standardEventId === "netRevenuePerOrder"
          ? ["Product AOV", "Shipping AOV"]
          : undefined,
      dataTypes: [
        keyMetric?.standardEventId
          ? STANDARD_EVENTS_ALLOWED_KEY_METRICS[keyMetric.standardEventId]
              .analyticsDataType
          : "percent",
      ] as DataType[],
      impactCalculationColoring:
        keyMetric?.standardEventId &&
        InvertedMetrics.includes(keyMetric.standardEventId)
          ? "inverted"
          : "normal",
    };
  });
}
